import olOSM, {ATTRIBUTION} from './../../node_modules/ol/source/OSM.js';

class OSM extends olOSM {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}
export {ATTRIBUTION};

export default OSM;